<div class="pc-page-shell">
  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">

      <div class="filter-header">
        <div class="filter-header__title">
          <mat-icon aria-hidden="true">filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>
        <mat-icon class="close-btn" (click)="isFilterOpen = false">close</mat-icon>
      </div>

      <!-- Body -->
      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Vessel Name"
            placeholder="Select Vessel Name"
            [options]="getFilterOptions('vesselName')"
            [(selected)]="fieldSelections.vesselName">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="IMO Number"
            placeholder="Select IMO Number"
            [options]="getFilterOptions('imoNumber')"
            [(selected)]="fieldSelections.imoNumber">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Segment"
            placeholder="Select Segment"
            [options]="getFilterOptions('segment')"
            [(selected)]="fieldSelections.segment">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Yard"
            placeholder="Select Yard"
            [options]="getFilterOptions('yard')"
            [(selected)]="fieldSelections.yard">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Year Built"
            placeholder="Select Year Built"
            [options]="getFilterOptions('yearBuilt')"
            [(selected)]="fieldSelections.yearBuilt">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Technical Operator"
            placeholder="Select Technical Operator"
            [options]="getFilterOptions('technicalOperator')"
            [(selected)]="fieldSelections.technicalOperator">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Commercial Operator"
            placeholder="Select Commercial Operator"
            [options]="getFilterOptions('commercialOperator')"
            [(selected)]="fieldSelections.commercialOperator">
          </app-pc-multi-select-filter>
        </div>

        <div class="filter-section">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Class"
            placeholder="Select Class"
            [options]="getFilterOptions('class')"
            [(selected)]="fieldSelections.class">
          </app-pc-multi-select-filter>
        </div>

      </form>

      <!-- Footer -->
      <div class="filter-footer">
        <button type="button" class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear Filter
        </button>

        <button type="button" class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
      </div>

    </div>
  </div>
  <div class="filter-overlay" *ngIf="isFilterOpen" (click)="isFilterOpen = false"></div>

  <div class="container">
  <div class="page-header">
    <button
      *ngIf="fromOnboardingForm"
      type="button"
      class="btn fetchData app-back-btn"
      (click)="goBack()"
    >
      <mat-icon>arrow_back</mat-icon>
      <span>Back</span>
    </button>
    <p class="title">
      Vessel Questionnaire
    </p>
  </div>
  <mat-icon class="filter-top-btn" (click)="isFilterOpen = true" matTooltip="Table Filter">
    filter_list
  </mat-icon>

  <div class="active-filter-bar" *ngIf="activeFilterColumns.length">

    <div class="filter-chip" *ngFor="let chip of activeFilterColumns"
      [class.active]="selectedDynamicColumn === chip.key" [class.disabled]="!chip.active"
      (click)="chip.active && selectDynamicColumn(chip)">
      <mat-icon class="chip-icon">tune</mat-icon>

      <span class="chip-label">
        {{ chip.label }}
      </span>

      <span class="chip-count">
        {{ chip.count }}
      </span>
    </div>

  </div>
  <!-- Top Table: Always visible -->
  <h3 *ngIf="!paginatedData.length">Vessel List</h3>
  <div class="table-container scroll-bar" *ngIf="!paginatedData.length">
    <table matSort #sort="matSort" class="mat-elevation-z8" id="style-4" [ngClass]="{ 'dark-table': isDarkMode() }">
      <thead class="sticky-header">
        <tr>
          <th>Sr No.</th>
          <th mat-sort-header="vessel_name">Vessel Name</th>
          <th mat-sort-header="imo_number">IMO Number</th>
          <th mat-sort-header="segment">Segment</th>
          <th mat-sort-header="extraction_timestamp">Questionnaire Uploaded</th>
          <th *ngIf="selectedDynamicColumn">
            {{ formatHeader(selectedDynamicColumn) }}
          </th>
          <th class="text-center">PDF Download</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of tableData; let i = index" [ngClass]="{'new-row-highlight': item.isNew}">
          <td>
            {{ i + 1 }}
            <span *ngIf="item.isNew" class="new-badge">NEW</span>
          </td>
          <td (click)="filterByVesselAndImo(item.vessel_name, item.imo_number)">
            {{ toTitleCase(item.vessel_name) }}
          </td>

          <td (click)="filterByVesselAndImo(item.vessel_name, item.imo_number)">
            {{ item.imo_number }}
          </td>

          <td>
            {{ item.segment || '-' }}
          </td>

          <td>
            {{ item.extraction_timestamp | date:'dd-MMM-yyyy, HH:mm':'' }}
          </td>
          <td *ngIf="selectedDynamicColumn">
            {{ item[selectedDynamicColumn] || '-' }}
          </td>
          <td class="text-center">
            <button mat-icon-button matTooltip="Download PDF" (click)="downloadPdf(item); $event.stopPropagation()"
              class="download-btn">
              <mat-icon color="primary">download</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator *ngIf="!paginatedData.length" [length]="filteredData.length" [pageSizeOptions]="[100]"
    [pageSize]="itemsPerPage" (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }"
    showFirstLastButtons></mat-paginator>

  <!-- Detailed Table: Only visible when row is selected -->
  <div *ngIf="paginatedData.length > 0">
    <!-- <div class="title-container">
      <h3 class="title">Detailed Report</h3>
      <mat-icon
        class="toggle-icon"
        matTooltip="{{
          isExpanded ? 'Click here to collapse' : 'Click here to expand'
        }}"
        (click)="toggleExpand()"
      >
        {{ isExpanded ? "fullscreen_exit" : "fullscreen" }}
      </mat-icon>
    </div>
    <div  class="table-header" *ngIf="vesselName && paginatedData.length > 0">
      <h3 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
        Vessel Details: {{ vesselName }}
      </h3>
    </div> -->

    <div class="q88-report-card" *ngIf="paginatedData.length > 0">
      <div class="report-header">
        <div>
          <h2>{{ vesselName }}</h2>
          <p> Vessel Information Sheet</p>
        </div>

        <button class="close-detail-btn" (click)="resetFilter()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="report-grid" *ngFor="let row of paginatedData">

        <div class="report-row" *ngFor="let key of tableHeaders">

          <div class="report-label">
            {{ formatHeader(key) }}
          </div>

          <div class="report-value">

            <!-- Simple text -->
            <ng-container *ngIf="
      !isObject(row[key]) &&
      !isArrayOfObjects(row[key]) &&
      !isSimpleArray(row[key])
    ">
              {{ row[key] || '—' }}
            </ng-container>

            <!-- Simple Array -->
            <ng-container *ngIf="isSimpleArray(row[key])">
              <div class="chip-wrap">
                <span class="data-chip" *ngFor="let item of row[key]">
                  {{ item }}
                </span>
              </div>
            </ng-container>

            <!-- Object -->
            <ng-container *ngIf="isObject(row[key])">
              <div class="nested-card">

                <div class="nested-row" *ngFor="let item of row[key] | keyvalue">
                  <div class="nested-label">
                    {{ formatHeader(asString(item.key)) }}
                  </div>

                  <div class="nested-value">

                    <!-- Nested array inside object -->
                    <ng-container *ngIf="isArrayOfObjects(item.value)">
                      <div class="mini-table-card" *ngFor="let sub of asArray(item.value)">
                        <div class="mini-row" *ngFor="let val of sub | keyvalue">
                          <span>
                            {{ formatHeader(asString(val.key)) }}
                          </span>

                          <strong>
                            {{ val.value || '—' }}
                          </strong>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Simple nested value -->
                    <ng-container *ngIf="!isArrayOfObjects(item.value)">
                      {{ item.value || '—' }}
                    </ng-container>

                  </div>
                </div>

              </div>
            </ng-container>

            <!-- Array of Objects -->
            <ng-container *ngIf="isArrayOfObjects(row[key])">
              <div class="mini-grid">

                <div class="mini-card" *ngFor="let obj of row[key]">
                  <div class="mini-row" *ngFor="let item of obj | keyvalue">
                    <span>
                      {{ formatHeader(asString(item.key)) }}
                    </span>

                    <strong>
                      {{ item.value || '—' }}
                    </strong>
                  </div>
                </div>

              </div>
            </ng-container>

          </div>

        </div>

      </div>
    </div>

    <div class="text-right">
      <button class="btn btn-light hover-button apply mt-2" (click)="resetFilter()">
        Hide Details
      </button>
    </div>
  </div>
</div>
</div>